import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from 'redux';
import { changeItemQuantity, deleteOrderItem } from '../redux/actions/orderActions';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import IPosModal from "../IPosModal";
import './quantity.scss';

const Quantity = ({ orderItem: item, changeItemQuantity, deleteOrderItem, t }) => {
  const increase = () => {
    const newQuantity = item.orderItem.quantity + 1;
    changeItemQuantity(item, newQuantity);
  };
  const decrease = () => {
    const currentQuantity = item.orderItem.quantity;
    const newQuantity = (currentQuantity - 1) <= 0 ? 1 : currentQuantity - 1;
    changeItemQuantity(item, newQuantity);
  };
  const destory = () => {
    IPosModal.confirmation({
      title: t('dialogs.destroying_item', { name: item.menuItem.item_name }),
      message: t('dialogs.are_you_sure'),
      okButtonText: t('buttons.delete'),
      cancelButtonText: t('buttons.cancel'),
      onOk: () => {
        deleteOrderItem(item);
      }, onClose: () => {
        return;
      }
    });
  };

  return (
    <div className="quantity-block">
      <div className="decrease-block" onClick={ item.orderItem.quantity === 1 ? destory : decrease}>
        { item.orderItem.quantity === 1
          ?
          <FontAwesomeIcon icon="trash"  />
          :
          <FontAwesomeIcon icon="minus-circle"  />
        }

      </div>
      <div className="quantity-number">
        { item.orderItem.quantity }
      </div>
      <div className="increase-block" onClick={ increase }>
        <FontAwesomeIcon icon="plus-circle"  />
      </div>
    </div>
  );

};

const mapStateToProps = (state) => {
  const {
    orderItems
  } = state;

  return {
    orderItems
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changeItemQuantity,
      deleteOrderItem
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Quantity);
